module.exports = __webpack_public_path__ + "img/223.67c3d6b0.png";